import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import EventForm from '../../components/EventForm';
import Buttons from './Buttons';
import useStepController from './useStepController';
import useFieldsController from './useFieldsController';

import { directions } from '../../store/selectors/formCollections';

const Wrapper = ({
  handleSubmit,
  isValid,
  isLast,
  setStep,
  setValue,
  values,
  directions,
  ...props
}) => {
  useFieldsController(values, setValue, { directions });
  useStepController(values, setStep);

  return (
    <EventForm operation="write" values={values} setValue={setValue} {...props}>
      <Buttons handleSubmit={handleSubmit} isValid={isValid} isLast={isLast} />
    </EventForm>
  );
};

Wrapper.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired,
  values: PropTypes.shape({}).isRequired,
  setStep: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  directions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = state => {
  return {
    directions: directions(state),
  };
};

export default connect(mapStateToProps)(Wrapper);
